import { Component, Element, h, Host } from '@stencil/core'

import { CssClassMap } from '../../../utils/interfaces'

/**
 * ## Design System
 *
 * O br-table-body é um subcomponent da tabela que tem a função de agrupar as linhas de conteúdo da tabela, representadas pelo subcomponente br-table-row.
 * Ele é utilizado para organizar e estruturar o conteúdo do corpo da tabela, permitindo a definição de múltiplas linhas de conteúdo, cada uma contendo células de conteúdo representadas pelo subcomponente br-table-cell.
 *
 * @remarks
 * Para a documentação completa de design, incluindo diretrizes de uso, acessibilidade e exemplos visuais, consulte o [Design System do GovBR](https://www.gov.br/ds/components/table?tab=designer).
 *
 * @Slot default: Área para inclusão do subcomponente br-table-row, que representa as linhas de conteúdo da tabela.
 */
@Component({
  tag: 'br-table-body',
  styleUrl: 'table-body.scss',
  shadow: true,
})
export class TableBody {
  /**
   * Referência ao elemento host do componente.   *
   * Utilize esta propriedade para acessar e manipular o elemento do DOM associado ao componente.
   */
  @Element() el!: HTMLBrTableBodyElement

  /**
   * Retorna o mapa de classes base do componente.
   *
   * @returns Um objeto representando as classes CSS a serem aplicadas ao elemento do corpo da tabela.
   */
  private getBodyCssClassMap(): CssClassMap {
    return {
      'br-table-body': true,
    }
  }

  /**
   * Renderiza o host do componente.
   *
   * @returns JSX.Element representando o elemento host do componente, contendo a estrutura do corpo da tabela.
   */
  render() {
    return (
      <Host role="rowgroup">
        <div class={this.getBodyCssClassMap()} role="presentation">
          <slot></slot>
        </div>
      </Host>
    )
  }
}
